import React from 'react';
import Button from '../Button';
import classNames from 'classnames';

import { IDoubleButton } from './interface';
import './index.less';

const Index = ({
  icon,
  loading,
  disabled,
  children,
  className = '',
  style = {},
  logValue,
  onClick,
  ...rest
}: IDoubleButton) => {
  return (
    <Button
      type="link"
      className={classNames('fs-dbButton', className)}
      loading={loading}
      disabled={disabled}
      style={style}
      data-log-value={logValue}
      onClick={onClick}
      {...rest}
    >
      {loading ? null : icon}
      <div className="fs-dbButton-child">{children}</div>
    </Button>
  );
};

export default Index;
